import type { TMapOptions } from '~/misc/v-map/types';

export const mapLibConfigInjectionKey = Symbol('mapLibConfig');

export const INITIAL_ZOOM_FACTOR: number = 16;

export const MAP_STYLES: TMapOptions['styles'] = [
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
];
